export default "<router-outlet></router-outlet>\r\n<app-alert></app-alert>\r\n"